import Cookies from 'js-cookie';
import { getSSODomain } from 'config/configure';
import { TOKEN_KEYS } from '../constants';
import { Storage } from '../types';
import { COOKIE_EXPIRATION_DAYS, COOKIE_NAME } from './constants';
import { CookieValue } from './types';

function isEmpty(value: CookieValue) {
  return Object.values(TOKEN_KEYS).every((key) => value[key] === undefined);
}

function readCookie(): CookieValue | undefined {
  const value = Cookies.get(COOKIE_NAME);

  if (!value) {
    return undefined;
  }

  return JSON.parse(value);
}

function writeCookie(value: CookieValue): void {
  Cookies.set(COOKIE_NAME, JSON.stringify(value), {
    domain: getSSODomain(),
    // NB: Browsers typically have restrictions for how long a Cookie created from
    // javascript can live.  Even if the expiration is a year in the future, in practice
    // the browser might set the expiration to something different - like 1 week
    // or even 1 day
    expires: COOKIE_EXPIRATION_DAYS,
  });
}

function removeCookie() {
  Cookies.remove(COOKIE_NAME, { domain: getSSODomain() });
}

function updateCookie(updater: (value: CookieValue) => CookieValue): void {
  const currentValue = readCookie();
  const newValue = updater(currentValue ?? {});

  if (!newValue || isEmpty(newValue)) {
    removeCookie();
  } else {
    writeCookie(newValue);
  }
}

const cookieStorage: Storage = {
  clearToken(key) {
    updateCookie((value) => {
      const clone = { ...value };
      delete clone[key];
      return clone;
    });
  },
  getToken(key) {
    const value = readCookie();
    return !value ? undefined : value[key];
  },
  setToken(key, token) {
    updateCookie((value) => ({
      ...value,
      [key]: token,
    }));
  },
};

export default cookieStorage;
